// extracted by mini-css-extract-plugin
export default {"error_container":"error_error_container__vbpdE"};